export type DynamicModelGridResult = {
  rows: Record<string, unknown>[];
  count: number;
};

/** Normalize `grid_data` API payloads (array, nested `data`, etc.). */
export function normalizeDynamicModelGrid(
  payload: unknown
): DynamicModelGridResult {
  if (!payload || typeof payload !== "object") {
    return { rows: [], count: 0 };
  }

  const root = payload as Record<string, unknown>;

  const pickRows = (obj: Record<string, unknown>): unknown[] | null => {
    const grid = obj.grid_data;
    if (Array.isArray(grid)) {
      return grid;
    }
    const results = obj.results;
    if (Array.isArray(results)) {
      return results;
    }
    const data = obj.data;
    if (Array.isArray(data)) {
      return data;
    }
    if (data && typeof data === "object") {
      const nested = data as Record<string, unknown>;
      if (Array.isArray(nested.grid_data)) {
        return nested.grid_data;
      }
      if (Array.isArray(nested.results)) {
        return nested.results;
      }
    }
    return null;
  };

  let rows = pickRows(root);
  if (!rows && Array.isArray(payload)) {
    rows = payload;
  }

  const safeRows = (rows ?? []).filter(
    (r): r is Record<string, unknown> => !!r && typeof r === "object"
  );

  const countRaw = root.count ?? root.total ?? root.total_count;
  const count =
    typeof countRaw === "number" && countRaw >= 0
      ? countRaw
      : safeRows.length;

  return { rows: safeRows, count };
}
